import type { ReactNode } from 'react';

import { cn } from '@playbook/utils';

import css from './styles.module.css';

type BackdropVariant = 'none' | 'grid' | 'ripple' | 'wave';

interface BackdropProps {
	variant?: BackdropVariant;
	opacity?: number;
}

export function Backdrop({
	variant = 'none',
	opacity = 1,
}: BackdropProps): ReactNode {
	return (
		<div aria-hidden="true" className={cn(css.backdrop, css[variant])}>
			<div className={css.wash} style={{ opacity }} />
		</div>
	);
}
